import { useEffect, useState } from "react";
import { Image, View, Text } from 'react-native';

import { TouchableRipple } from 'react-native-paper';
import React from "react";
import { DropdownComponent } from "../../../components/forms/DropdownComponent";
import { useQuery } from "@apollo/client";
import { GET_TEMPLATES } from "../../templates/graphql/query";
import { GROUP_API_KEYS } from "../../profile/graphql/query";
import { ChecksDropdownComponent } from "../../../components/forms/ChecksDropdownComponent";

interface IHeadersMovile {
    setShowHeaders: any;
    onHandleSelectTemplate: any;
    setPlaceholderTemplateApp: any;
    placeholderTemplateApp: any;
    setModelsSelected: any;
    modelsSelected: any;
    setGeneralPrompt: any;
    template: any;
}


export default function HeadersMovile({ setShowHeaders, onHandleSelectTemplate, setPlaceholderTemplateApp, placeholderTemplateApp, setModelsSelected, modelsSelected, setGeneralPrompt, template }: IHeadersMovile) {

    const [templates, setTemplates] = useState([]);
    const [models, setModels] = useState([]);
    const [placeholderModel, setPlaceholderModel] = useState("Selecciona un modelo");

    const [selectedModels, setSelectedModels] = useState([] as any);

    const { data: dataTemplates, loading: loadingTemplates, error: errorTemplates } = useQuery(GET_TEMPLATES);
    const { data: dataApiKeys, loading: loadingApiKeys, error: errorApiKeys } = useQuery(GROUP_API_KEYS);


    const handleSelectTemplate = (item: any) => {

        setPlaceholderTemplateApp(item.label);
        setGeneralPrompt(item.data.instructions + ", " + item.data.output);
        onHandleSelectTemplate(item.data.instructions, item.data.output, item.value, item.label);
        setShowHeaders(false)  

    }

    const handleSelectModel = async (item: any) => {

        let selected = selectedModels.find((element: any) => element[0] === item[0]);

        if (selected) {
            setSelectedModels(selectedModels.filter((element: any) => element[0] !== item[0]));
            setModelsSelected(selectedModels.filter((element: any) => element[0] !== item[0]));
        }
        else {
            if (selectedModels.length < 3) {
                setSelectedModels([...selectedModels, item]);
                setModelsSelected([...selectedModels, item]);
            }
        }

    }

    useEffect(() => {

        if (dataTemplates) {
            setTemplates(dataTemplates?.templetesRecent?.map((item: any) => {
                return {
                    label: item.name,
                    value: item.id,
                    data: {
                        instructions: item.instructions,
                        output: item.output
                    }
                }
            }))
        }

        if (template?.name) {
            setPlaceholderTemplateApp(template.name);
        }

    }, [dataTemplates, template]);

    useEffect(() => {

        if (dataApiKeys) {
            setModels(dataApiKeys.groupApiKeys.map((item: any) => {
                return {
                    label: item.name,
                    value: item.id,
                }
            }));
        }

    }, [dataApiKeys]);

    useEffect(() => {
        let place = "";

        if (selectedModels.length === 0) {
            setPlaceholderModel("Selecciona un modelo");

            return;
        }


        if (selectedModels.length > 0 && models.length > 0) {
            selectedModels.forEach((element: any) => {
                let name: any = models.find((model: any) => model.value === element[0]);
                if (name)
                    place += name.label + ", ";
            }
            );

            place = place.substring(0, place.length - 2);

            setPlaceholderModel(place);
        }

    }, [selectedModels]);

    useEffect(() => {
        if (modelsSelected.length != 0 && dataApiKeys) {
            setSelectedModels(modelsSelected);
            setModelsSelected(modelsSelected);

            let place = "";
            modelsSelected.forEach((element: any) => {
                let name: any = dataApiKeys?.groupApiKeys.find((model: any) => model.id === element[0]);
                if (name)
                    place += name.label + ", ";
            }
            );

            place = place.substring(0, place.length - 2);

            setPlaceholderModel(place);
        }
    }, [modelsSelected, dataApiKeys]);



    return (
        <View className={`h-screen w-screen items-center justify-center absolute top-0 left-0 z-50 bg-[#27374D]`}>

            <View className="flex flex-row-reverse">
                <TouchableRipple
                    onPress={() => { setShowHeaders(false) }}
                >
                    <Image
                        source={require('../../../../assets/close.svg')}
                        style={{ width: 25, height: 25 }}
                        className="hover:opacity-50 cursor-pointer mr-4 mt-4"
                    />
                </TouchableRipple>
            </View>

            <View className="flex flex-col">

                <View className="flex flex-col items-center justify-center">
                    <Text className="text-white text-base font-semibold mr-3">Template </Text>
                    {
                        loadingTemplates ? (
                            <View className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white" />

                        ) : (
                            <View className=" w-56">

                                <DropdownComponent
                                    data={templates}
                                    onChange={handleSelectTemplate}
                                    placeholder={placeholderTemplateApp}

                                />

                            </View>
                        )
                    }

                </View>

                <View className="flex flex-col items-center justify-center">
                    <Text className="text-white text-base font-semibold mr-3">Modelo </Text>

                    {
                        loadingApiKeys ? (
                            <View className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white" />

                        ) : (
                            <View className=" w-56">

                                <ChecksDropdownComponent
                                    data={models}
                                    onChange={handleSelectModel}
                                    placeholder={placeholderModel}
                                    selectedItems={selectedModels}
                                />

                            </View>
                        )
                    }

                </View>
            </View>


        </View>
    )
}